import { useState } from "react";
import { api } from "../lib/api";
import { getWorkspace, setWorkspace } from "../lib/workspaceStore";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export default function BrandingPage() {
  const ws = getWorkspace();
  const branding = ws?.branding || {};
  
  const [brandName, setBrandName] = useState(branding.brand_name || "");
  const [logoUrl, setLogoUrl] = useState(branding.logo_url || "");
  const [accentColor, setAccentColor] = useState(branding.accent_color || "#6C4AF2");
  const [whiteLabel, setWhiteLabel] = useState(branding.white_label || false);
  const [saving, setSaving] = useState(false);

  async function save() {
    if (!ws) return;
    setSaving(true);
    try {
      await api.patch(`/api/workspaces/${ws.id}/branding`, {
        brand_name: brandName,
        logo_url: logoUrl,
        accent_color: accentColor,
        white_label: whiteLabel,
      });
      // Update local workspace with new branding
      setWorkspace({ ...ws, branding: { brand_name: brandName, logo_url: logoUrl, accent_color: accentColor, white_label: whiteLabel } });
    } catch (e) {
      alert(e?.response?.data?.detail || "Failed to save branding.");
      setSaving(false);
    }
  }

  if (!ws) {
    return (
      <div className="space-y-6">
        <div className="text-2xl font-semibold">White-Label Branding</div>
        <Card>
          <CardContent className="py-4 text-muted-foreground">
            No workspace selected.
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="branding-page">
      <div className="text-2xl font-semibold">White-Label Branding</div>

      <Card>
        <CardHeader>
          <CardTitle>Workspace Brand</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium">Brand Name</label>
            <Input
              placeholder="Brand name"
              value={brandName}
              onChange={(e) => setBrandName(e.target.value)}
              data-testid="brand-name-input"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Logo URL</label>
            <Input
              placeholder="https://example.com/logo.png"
              value={logoUrl}
              onChange={(e) => setLogoUrl(e.target.value)}
              data-testid="logo-url-input"
            />
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Accent Color</label>
            <div className="flex gap-2">
              <Input
                type="color"
                value={accentColor}
                onChange={(e) => setAccentColor(e.target.value)}
                className="w-16 h-10 p-1"
                data-testid="accent-color-input"
              />
              <Input
                value={accentColor}
                onChange={(e) => setAccentColor(e.target.value)}
                className="flex-1"
              />
            </div>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="whiteLabel"
              checked={whiteLabel}
              onChange={(e) => setWhiteLabel(e.target.checked)}
              data-testid="white-label-checkbox"
            />
            <label htmlFor="whiteLabel" className="text-sm">
              Enable white-label mode (hide "AI Marketing Platform" subtitle)
            </label>
          </div>

          <Button onClick={save} disabled={saving} data-testid="save-branding-btn">
            {saving ? "Saving..." : "Save"}
          </Button>
        </CardContent>
      </Card>

      {/* Preview */}
      <Card>
        <CardHeader>
          <CardTitle>Preview</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="border rounded-lg p-4 bg-background">
            {logoUrl ? (
              <img src={logoUrl} alt={brandName} className="h-8 mb-1" />
            ) : (
              <div className="text-lg font-semibold" style={{ color: accentColor }}>
                {brandName || "Your Brand"}
              </div>
            )}
            {!whiteLabel && (
              <div className="text-xs text-muted-foreground">AI Marketing Platform</div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
